import { getApiquery } from "./apiService";

export const getDashboardData = async (queryParams) => {
    return await getApiquery("/mp/dashboard/summary", queryParams);
};

export const getRevenueTrend = async (queryParams) => {
    return await getApiquery("mp/dashboard/revenue/trends", queryParams);
};

export const getSubscriptionRevenueBreakdown = async (queryParams) => {
    return await getApiquery("mp/dashboard/revenue/subscription-breakdown", queryParams);
};

export const getCompletedOrdersTrend = async (queryParams) => {
    return await getApiquery("mp/dashboard/revenue/orders/completed-trend", queryParams);
};

export const getClassBookingsBreakdown = async (queryParams) => {
    return await getApiquery("mp/dashboard/revenue/class/booking-trend", queryParams);
};

export const getRatingDistribution = async (queryParams) => {
    return await getApiquery("mp/dashboard/revenue/rating/rating-trend", queryParams);
};

export const getPendingPayoutTrend = async (queryParams) => {
    return await getApiquery("mp/dashboard/merchant/payment/payout-trend", queryParams);
};
